/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GARIds } from "./GARIds";
import { GARIdsFromJSON, GARIdsFromJSONTyped, GARIdsToJSON, GARIdsToJSONTyped } from "./GARIds";

/**
 *
 * @export
 * @interface ApiGarIdsList200Response
 */
export interface ApiGarIdsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGarIdsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGarIdsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGarIdsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GARIds>}
   * @memberof ApiGarIdsList200Response
   */
  results: Array<GARIds>;
}

/**
 * Check if a given object implements the ApiGarIdsList200Response interface.
 */
export function instanceOfApiGarIdsList200Response(
  value: object
): value is ApiGarIdsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGarIdsList200ResponseFromJSON(json: any): ApiGarIdsList200Response {
  return ApiGarIdsList200ResponseFromJSONTyped(json, false);
}

export function ApiGarIdsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGarIdsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GARIdsFromJSON),
  };
}

export function ApiGarIdsList200ResponseToJSON(json: any): ApiGarIdsList200Response {
  return ApiGarIdsList200ResponseToJSONTyped(json, false);
}

export function ApiGarIdsList200ResponseToJSONTyped(
  value?: ApiGarIdsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GARIdsToJSON),
  };
}
